<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                        v-model="search"
                        :clearable="true"
                        :autofocus="true"
                        placeholder="Search"
                        class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
                :base-url="urlWithFilters"
                ref="baseTable"
                @load-success="onLoadSuccess"
                @refresh="onRefresh"
                :current-page="currentPage"
                v-loading="isRefreshing"
                element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                        :data="items"
                        stripe
                        class="w-100"
                >
                    <el-table-column type="expand" v-slot="{row}">
                        <expand-column :row="row"></expand-column>
                    </el-table-column>
                    <el-table-column
                            prop="model.id"
                            label="Id"
                            min-width="80"
                    ></el-table-column>
                    <el-table-column
                            prop="model.name"
                            label="Name"
                            min-width="400"
                    ></el-table-column>
                    <el-table-column
                            prop="model.created_at"
                            label="Created at"
                            min-width="120"
                            :formatter="formatDate"
                    ></el-table-column>
                    <el-table-column
                            label="Actions"
                            v-slot="{row}"
                    >
                        <el-tooltip
                                effect="light"
                                placement="top-start"
                                :open-delay="300"
                                content="Create a campaing from the template"
                        >
                            <button class="btn btn-success btn-sm" @click="select(row)">
                                <i class="fas fa-check"></i>
                            </button>
                        </el-tooltip>
                    </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ExpandColumn from './item-picker-expand-column';
  import {strLimit} from "../../helpers";

  export default {
    extends: TableWithPagination,

    components: {
      ExpandColumn,
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },

    watch: {
      search: function (value) {
        if (value) {
          this.filters = _.assign({}, this.filters, {search: value});
        } else {
          this.filters = _.omit(this.filters, ['search']);
        }
      },
    },

    methods: {
      /**
       * @param {object} row
       * @param {object} col
       * @param {string} datetime
       */
      formatDate(row, col, {datetime}) {
        return moment(datetime).format(config('format.moment.short.datetime'));
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {string} value
       * @return {string}
       */
      formatMessage(row, col, value) {
        return strLimit(String(value), 50);
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {object} row
       */
      select(row) {
        this.$emit('select', row);
      },
    }
  }
</script>

